// IP 合作「联动上线时长」组合控件（InputNumber + 单位 Select），内包/外包共享。
// 源实现来自 SecondaryOnlineDetailTable 联动上线时长列，抽取为独立组件供 NegotiationTable SolutionTable 复用。
import React from 'react';
import { InputNumber, Select } from '@bedrock/components';
import { DURATION_UNIT_OPTIONS } from './utils';

/** 联动上线时长组合值（duration 数值 + unit 单位），对齐后端 OnlineLinkItem duration/unit 契约 */
export interface DurationValue {
  duration?: number;
  unit?: 'WEEK' | 'MONTH';
}

/** 只读格式化：无值 → '--'；否则 `数值 + 单位名`（'周'/'月'） */
export function formatDurationValue(value?: DurationValue): string {
  if (value?.duration == null) return '--';
  const unitLabel =
    DURATION_UNIT_OPTIONS.find((o) => o.value === value.unit)?.name || '';
  return `${value.duration}${unitLabel}`;
}

/** 自定义组合控件：InputNumber + 单位 Select（addonAfter），镜像 SFormItem demo NameCodeInput 受控范式 */
const DurationInput: React.FC<{
  value?: DurationValue;
  onChange?: (v: DurationValue) => void;
}> = ({ value = {}, onChange }) => {

  return (
    <InputNumber
      value={value.duration}
      onChange={(val) => onChange?.({ ...value, duration: val ?? undefined })}
      min={0}
      precision={0}
      placeholder="请输入"
      direction="vertical"
      addonAfter={
        <Select
          value={value.unit}
          onChange={(val) =>
            onChange?.({ ...value, unit: val as 'WEEK' | 'MONTH' })
          }
          options={DURATION_UNIT_OPTIONS}
          bordered={false}
          style={{ width: 70 }}
        />
      }
    />
  );
};

export default DurationInput;
